import { LocationType, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACCOUNT_API_NAMES } from './apis';
import { subscribeHoldings, unsubscribeHoldings } from './holdingsActions';
import { IStore, ACCOUNT_STORE_NAME } from './store';
import { AccountKey } from './types';

export const useSubscribeHoldings = (location: LocationType, accountNo: AccountKey) => {
  const dispatch = useDispatch();
  const holdings = useSelector((store: IStore) => store[ACCOUNT_STORE_NAME].holdings[accountNo]);
  const { polling, error, fetching } = useFrontendSubscriptionStatus(ACCOUNT_STORE_NAME, ACCOUNT_API_NAMES.AccountHoldingsLeanGet2, accountNo);
  const [prevAccountNo, setPrevAccountNo] = useState<AccountKey>(accountNo);

  useEffect(() => {
    dispatch<any>(subscribeHoldings(location, accountNo));
    return () => {
      dispatch<any>(unsubscribeHoldings(location, accountNo));
    };
  }, []);

  useEffect(() => {
    if (accountNo === prevAccountNo) return;

    dispatch<any>(unsubscribeHoldings(location, prevAccountNo));
    dispatch<any>(subscribeHoldings(location, accountNo));
    setPrevAccountNo(accountNo);
    return () => {
      dispatch<any>(unsubscribeHoldings(location, accountNo));
    };
  }, [accountNo]);

  return {
    loading: fetching,
    polling,
    error,
    data: holdings,
    fetching
  };
};
